'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroToggle = require('./NitroToggle');

var _NitroToggle2 = _interopRequireDefault(_NitroToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroToggle2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-toggle/index.js
// module id = 767
// module chunks = 4